import * as yup from "yup";
import i18n from "i18next";
import { INPUT_LENGTH } from "@duosoftbg/nacid-components";

const typeValidationSchema = yup.object({
  id: yup.string().required("validation.field.required"),
});

export const createGlobalMessageSaveValidationSchema = () => {
  yup.setLocale({
    string: {
      matches: i18n.t("validation.field.invalid"),
    },
    mixed: {
      default: i18n.t("validation.field.invalid"),
      required: i18n.t("validation.field.required"),
    },
  });

  return yup.object({
    name: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    nameEn: yup.string().required().max(INPUT_LENGTH.MAX_INPUT_LENGTH_255, i18n.t("validation.charCount.invalid.255")),
    text: yup.string().required(),
    textEn: yup.string().required(),
    type: typeValidationSchema,
    active: yup.boolean().required(),
  });
};
